import { Routes, Route } from "react-router-dom";
import type { I18nProvider } from "react-admin";
import Home from "@web/home/HomePage";
import LoginPage from "./auth/LoginPage";
import AdminShell from "./dashboard/AdminShell";
import CreateTrialAccountPage from "./auth/CreateTrialAccountPage";
import RegistrationCancelPage from "./auth/CancelPage";
import RegistrationSuccessPage from "./auth/SuccessPage";
import { AcceptInvitationPage } from "./account/AcceptInvitationPage";
import { RequestPasswordResetPage } from "./account/RequestPasswordResetPage";
import { ResetPasswordPage } from "./account/ResetPasswordPage";
import Datenschutz from "./home/Datenschutz";
import Impressum from "./home/Impressum";
import Agb from "./home/Agb";
import Nutzungsbedingungen from "./home/Nutzungsbedingungen";
import Avv from "./home/Avv";
import { DatenschutzApp } from "./home/DatenschutzApp";

export function AppRoutes({ i18nProvider }: { i18nProvider: I18nProvider }) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/datenschutz-app" element={<DatenschutzApp />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/signup" element={<CreateTrialAccountPage />} />
      <Route
        path="/onboarding/:registrationId/success"
        element={<RegistrationSuccessPage />}
      />
      <Route
        path="/onboarding/:registrationId/cancel"
        element={<RegistrationCancelPage />}
      />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard/*"
        element={<AdminShell i18nProvider={i18nProvider} />}
      />
      <Route path="/invitations/accept" element={<AcceptInvitationPage />} />
      <Route path="/password/reset/init" element={<RequestPasswordResetPage />} />
      <Route path="/password/reset" element={<ResetPasswordPage />} />

      <Route path="/legal/agb" element={<Agb />} />
      <Route path="/legal/nutzungsbedingungen" element={<Nutzungsbedingungen />} />
      <Route path="/legal/avv" element={<Avv />} />
    </Routes>
  );
}
